import { faArrowRight, faArrowRightLong } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Dialog } from '@headlessui/react'
import { IKImage } from 'imagekitio-react'
import React from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { changeActivationSkill } from '../../../redux/actions/contentPayer'

const ConfirmationModal = ({isModalEnabled, setIsModalEnabled, selectedSkill ,currentSkill,setTilebarItem }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  return (
    <Dialog
    open={isModalEnabled}
    onClose={() => null}
    as="div"
    style={{ zIndex: "9999999999" }}
    className="fixed inset-0 z-10 -mt-10 flex flex-col items-center justify-center overflow-y-auto md:mt-10 md:justify-start"
  >
    <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-70" />
    <Dialog.Title />
    <Dialog.Description />
    <div className="relative z-10 flex  w-11/12 flex-col items-center justify-center overflow-auto rounded-xl bg-white py-4 px-4  shadow-2xl  md:w-1/4 md:p-4 lg:w-1/4">
    <img
        urlEndpoint="https://assets.learntube.ai/files/"
        src={"https://assets.learntube.ai/files/Content_player/Reading_book_1.svg?updatedAt=1680195079357"}
        transformation={[{
            "height": "110",
            "width": "110",
        }]}
        className=""
    />
      <div className='text-xl font-medium mt-2'>Change Course</div>
      <div className='text-center text-md  leading-tight  mt-2 text-center'>Are you sure you want to continue changing your course?</div>
      <div className='flex justify-center items-center mt-2 w-full relatve'>
        <div className=' flex justify-center items-center mr-2 '>
          <div className="flex h-14 w-14 items-center justify-center ">
              <img
                src={currentSkill?.skill_thumbnail}
                alt="Course Icon"
                className="h-8 object-cover mr-2"
              />
          </div>
          <div className='text-start text-sm'>{currentSkill?.['skill-name']}</div>
        </div>
        <FontAwesomeIcon icon={faArrowRightLong} className='mr-2'/>
        <div className=' flex justify-center items-center '>
          <div className="flex h-14 w-14 items-center justify-center ">
              <img
                src={selectedSkill?.skill_thumbnail}
                alt="Course Icon"
                className="h-8 object-cover mr-2"
              />
            </div>
            <div className='text-start text-sm'>{selectedSkill?.['skill-name']}</div>
            </div>
      </div>
      <div className='flex justify-center items-center w-full mt-2'>
        <button className='bg-white mt-4 text-[#13B284] border-2 mr-1 border-[#13B284] px-4 py-2 rounded-lg w-1/2' onClick={(e)=> setIsModalEnabled(false)}>Cancel</button>
        <button className='bg-[#13B284] border-2 border-[#13B284] ml-1 mt-4 text-white px-4 py-2 rounded-lg w-1/2' onClick={(e)=> dispatch(changeActivationSkill(selectedSkill?.id,(successObj)=>{navigate(`/${selectedSkill?.['course_slug']}/${selectedSkill?.['skill_slug']}/${selectedSkill?.['first_mskill']}/${selectedSkill?.['first_lesson']}`); setIsModalEnabled(false); setTilebarItem('quiz')} ))}>Yes,Change</button>
      </div>
    </div>
  </Dialog>
  )
}

export default ConfirmationModal
